import { TaskStatus } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import type { DashboardBreakpoints, WidgetSizes } from '@frontend/grid-dashboard';
import { i18next } from '@frontend/i18n';

/**
 * Returns a localized label for a given task status.
 * @param status - The task status to get a label for.
 * @returns The translated status label ('Todo' or 'In Progress').
 */
export const getTaskStatusLabel = (status: TaskStatus): string => {
  if (status === TaskStatus.STATUS_TODO) {
    return i18next.t('Todo', { ns: 'task-center' });
  }

  return i18next.t('In Progress', { ns: 'task-center' });
};

/**
 * Returns a formatted task count for the widget.
 * @param count - The task count coming from the API.
 * @returns The count to display in the UI. If the count is greater than 99, it returns '99+'.
 */
export const getTaskCount = (count: number): string | number => {
  if (count > 99) {
    return '99+';
  }
  return count;
};

/**
 * Returns whether the widget width is considered small based on the current breakpoint.
 * @param currentBreakpoint - The current breakpoint of the widget.
 * @returns True if the widget width is small, false otherwise.
 */
export const isWidgetWidthSmall = (currentBreakpoint: DashboardBreakpoints, currentSize: WidgetSizes): boolean => {
  return ['extraSmall', 'small'].includes(currentBreakpoint) || currentSize === 'large-narrow';
};
